import axios from "axios"
//Variables para conexión y ambientes
let test = process.env.REACT_APP_test === "true",
  amb = test ? "RepTst_" : "RepPrd_",
  urlReps = process.env.REACT_APP_urlResp,
  cnxSeg = process.env.REACT_APP_cnxSeg,
  cnxAPI = process.env.REACT_APP_cnxAPI

//url base de api favor de cambiarlo para test
const urlBase = process.env.REACT_APP_urlBase
const urlPowerBi = process.env.REACT_APP_urlPowerBi

let instance = axios.create({
  baseURL: cnxAPI,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    "X-Requested-With": "XMLHttpRequest",
  },
})

//Función para mostrar notificaciones
function notifica(tipo, mssg, titulo) {
  var inp_tip = document.getElementById("Alrt_inp_Tipo"),
    inp_msg = document.getElementById("Alrt_inp_Mssg"),
    inp_ttl = document.getElementById("Alrt_inp_Ttl"),
    btn = document.getElementById("btn_Alert")
  inp_tip.value = tipo
  inp_msg.value = mssg
  inp_ttl.value = titulo
  btn.click()
}

//Función para mostrar u ocultar el loader
function show_ldr(so) {
  var btn = so
    ? document.getElementById("btn_show")
    : document.getElementById("btn_hide")
  btn.click()
}

function checkUser() {
  var j = sessionStorage.getItem(amb + "UD")
  if (j !== null) {
    window.location = "/user"
  }
}

function getName() {
  var j = sessionStorage.getItem(amb + "UD")
  if (j === null) {
    window.location = "/auth/login"
  } else {
    var js = JSON.parse(atob(unescape(decodeURIComponent(j))))
    return js.nombre
  }
}

function getIdUsuario() {
  var j = sessionStorage.getItem(amb + "UD")
  if (j === null) {
    window.location = "/auth/login"
  } else {
    var js = JSON.parse(atob(unescape(decodeURIComponent(j))))
    return js.idUsuario
  }
}

function getToken() {
  var info_ = sessionStorage.getItem(amb + "UD")
  var js = JSON.parse(atob(unescape(decodeURIComponent(info_))))

  return js.tkn
}

const form_validate = (values, required) => {
  let erros = {
    valid: true,
    message: null,
  }
  Object.keys(required).forEach(function (item) {
    if (required[item]) {
      if (
        values[item] === undefined ||
        values[item] === null ||
        values[item].length === 0
      ) {
        erros.valid = false
        erros.message = required[item].message
      } else if (values[item] !== undefined && values[item].length > 0) {
        if (required[item].rgx) {
          const { pattern, message } = required[item].rgx
          if (!pattern.test(values[item])) {
            erros.valid = false
            erros.message = message
          }
        }
      }
    }
  })
  return erros
}

const call_api = async ({ endpoint, data, method }) => {
  let response = false
  try {
    if (method === "POST") {
      response = await instance
        .post(`${cnxAPI}${endpoint}`, data)
        .then((res) => {
          return res.data
        })
    } else if (method === "GET") {
      response = await instance.get(`${cnxAPI}${endpoint}`).then((res) => {
        return res.data
      })
    } else if (method === "PUT") {
      response = await instance
        .put(`${cnxAPI}${endpoint}`, data)
        .then((res) => res.data)
    }
  } catch (error) {
    return false
  }
  return response
}

export {
  amb,
  urlReps,
  cnxSeg,
  cnxAPI,
  notifica,
  show_ldr,
  getName,
  checkUser,
  getIdUsuario,
  getToken,
  form_validate,
  urlBase,
  urlPowerBi,
  call_api,
}
